module.exports = __webpack_public_path__ + "24e004ab/img/cadBim.e369a02a.png";